import { Link } from "react-router";
import { ICategoryCardResponseModel } from "../../../core/models";
import "./categoryCard.scss";

export interface CategoryCardProps {
  card: ICategoryCardResponseModel;
}

const CategoryCard = ({ card }: CategoryCardProps) => {
  const pushEventForCardClick = () => {
    if (window && (window as any)["ReactNativeWebView"]) {
      (window as any)["ReactNativeWebView"].postMessage(
        JSON.stringify({
          message: "eventLogForCountly",
          eventName: "Ana Sayfa Buton",
          eventSegment: {
            baslik: card.title,
          },
          actionType: "event",
        })
      );
    }
  };

  return (
    <Link
      to={{
        pathname: card.link,
      }}
      className="category-card"
      onClick={pushEventForCardClick}
    >
      <img
        src={card.icon.src}
        width={50}
        height={50}
        alt={card.title}
        style={{ height: "auto", width: "50px" }}
      />
      <span>{card.title}</span>
    </Link>
  );
};

export default CategoryCard;
